import { connect } from 'react-redux'

import component from 'components/Options'

const mapActionCreators = {
}

const mapStateToProps = (state) => ({
  options: state.options
})

export default connect(mapStateToProps, mapActionCreators)(component)



// WEBPACK FOOTER //
// ./src/routes/Options/containers/OptionsContainer.js